function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
function setCurrClientCookie() {
 var currClientBtns = document.querySelectorAll("[data-current-customer]");
//  console.log(currClientBtns);
  if (currClientBtns) {
     currClientBtns.forEach(currClientBtn => {
      currClientBtn.addEventListener("click", () => {
      // console.log("dajemy ciasteczko! a nawet pięć!");
      setCookie("realclient", true, 365)
    })
  });
    // currClientBtn.addEventListener("click", setCookie("realclient", true, 365));
    // console.log("dajemy ciasteczko! a nawet pięć!");
  }
}
export default setCurrClientCookie;